<template>
	<div>
		<AutoCompleteInput
			v-model="customer.id"
			hide-details
			:items="items"
			:id="inputId"
			:loading="pageLoading"
			:disabled="pageLoading"
			:placeholder="placeholder"
			v-on:change="getCustomer(customer.id)"
			v-on:input="$emit('input', customer.id)"
			:rules="rules"
			:class="{ ...contentClass }"
		>
		</AutoCompleteInput>
		<div class="d-flex justify-space-between">
			<div class="pa-3 col-md-6 col-lg-4" v-if="!is_empty(customer_detail)">
				<div class="blue--text text--darken-4 text-uppercase">
					<b>Supplier</b>
				</div>
				<p class="mb-0" v-if="customer_detail.display_name">
					<v-icon size="16" class="mr-1">mdi-account</v-icon>{{ customer_detail.display_name }}
				</p>
				<p class="mb-0" v-if="customer_detail.phone">
					<v-icon size="16" class="mr-1">mdi-phone</v-icon>{{ customer_detail.phone }}
				</p>
				<p class="mb-0" v-if="customer_detail.email">
					<v-icon size="16" class="mr-1">mdi-email</v-icon>{{ customer_detail.email }}
				</p>
				<div class="d-flex" v-if="customer_detail.address_line_1 || customer_detail.address_line_2">
					<div>
						<v-icon size="16" class="mr-1">mdi-map</v-icon>
					</div>
					<div>
						<p class="mb-0" v-if="customer_detail.address_line_1">
							{{ customer_detail.address_line_1 }}
						</p>
						<p class="mb-0" v-if="customer_detail.address_line_2">
							{{ customer_detail.address_line_2 }}
						</p>
						<p class="mb-0" v-if="customer_detail.unit_number">
							{{ customer_detail.unit_number }}
						</p>
						<p class="mb-0" v-if="customer_detail.address_country">
							{{ customer_detail.address_country }}
						</p>
						<p class="mb-0" v-if="customer_detail.address_postal_code">
							{{ customer_detail.address_postal_codea }}
						</p>
					</div>
				</div>

				<!-- <v-checkbox
					hide-details
					label="Show Only this supplier product"
					class="mt-3 mb-0 p-0"
					:true-value="1"
					@change="$emit('showOnlySupplierProducts', showOnlySupplierProducts)"
					:false-value="0"
					v-model="showOnlySupplierProducts"
				></v-checkbox> -->
			</div>
			<div class="pa-3 col-md-6 col-lg-4" v-if="!is_empty(contact_person)">
				<div class="d-flex justify-space-between">
					<div>
						<div class="blue--text text--darken-4 text-uppercase no-wrap">
							<b>Person Incharge</b>
							<v-icon v-if="contact_person.primary" size="10" color="green" class="ml-1"
								>mdi-circle</v-icon
							>
							<v-menu offset-y max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-icon
										v-bind="attrs"
										v-on="on"
										size="18"
										color="blue darken-4"
										class="ml-3 cursor-pointer"
										>mdi-pencil-circle</v-icon
									>
								</template>
								<v-list dense style="padding: 8px !important">
									<v-list-item-group>
										<template v-for="(item, index) in contact_person_list">
											<v-list-item
												@click="handleContactPerson(item.id)"
												:key="index"
												:class="{ 'blue lighten-4': item.id === contact_person.id }"
											>
												<v-list-item-icon class="mr-2 position-relative">
													<v-icon :color="item.primary ? 'green' : ''">mdi-account-circle</v-icon>
													<v-icon v-if="item.primary" size="10" color="green" class="ml-1 billing-active"
														>mdi-circle</v-icon
													>
												</v-list-item-icon>
												<v-list-item-title class="text-truncate"
													>{{ item.barcode }}-{{ item.display_name }}</v-list-item-title
												>
											</v-list-item>
										</template>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>
						<p class="mb-0" v-if="contact_person.display_name">
							<v-icon size="16" class="mr-1">mdi-account</v-icon>{{ contact_person.display_name }}
						</p>
						<p class="mb-0" v-if="contact_person.phone">
							<v-icon size="16" class="mr-1">mdi-phone</v-icon>{{ contact_person.phone }}
						</p>
						<p class="mb-0 text-truncate" v-if="contact_person.email">
							<v-icon size="16" class="mr-1">mdi-email</v-icon>{{ contact_person.email }}
						</p>
					</div>
					<div></div>
				</div>
			</div>
			<div class="pa-3 col-md-6 col-lg-4" v-if="!is_empty(billing_address)">
				<div class="d-flex justify-space-between">
					<div>
						<div class="blue--text text--darken-4 text-uppercase">
							<b>Address</b>
							<v-menu offset-y max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-icon v-if="false" v-bind="attrs" v-on="on" size="16" class="ml-12 cursor-pointer"
										>mdi-pencil</v-icon
									>
								</template>
								<v-list dense style="padding: 8px !important">
									<v-list-item-group>
										<template v-for="(item, index) in billing_address_list">
											<v-list-item
												@click="handleBillingAddress(item.id)"
												:key="index"
												:class="{ 'blue lighten-4': item.id === billing_address.id }"
											>
												<v-list-item-icon class="mr-2">
													<v-icon>mdi-home-city-outline</v-icon>
												</v-list-item-icon>
												<v-list-item-title class="text-truncate"
													>{{ item.barcode }}-{{ item.address_line_1 }}</v-list-item-title
												>
											</v-list-item>
										</template>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>
						<p class="mb-0" v-if="billing_address.phone_no">
							<v-icon size="16" class="mr-1">mdi-phone</v-icon>{{ billing_address.phone_no }}
						</p>
						<p class="mb-0" v-if="billing_address.email">
							<v-icon size="16" class="mr-1">mdi-email</v-icon>{{ billing_address.email }}
						</p>
						<div class="d-flex" v-if="billing_address.address_line_1 || billing_address.address_line_2">
							<div>
								<v-icon size="16" class="mr-1">mdi-map</v-icon>
							</div>
							<div>
								<p class="mb-0" v-if="billing_address.location">
									{{ billing_address.location }}
								</p>
								<p class="mb-0" v-if="billing_address.address_line_1">
									{{ billing_address.address_line_1 }}
								</p>
								<p class="mb-0" v-if="billing_address.address_line_2">
									{{ billing_address.address_line_2 }}
								</p>
								<p class="mb-0" v-if="billing_address.unit_number">
									{{ billing_address.unit_number }}
								</p>
								<p class="mb-0" v-if="billing_address.address_country">
									{{ billing_address.address_country }}
								</p>
								<p class="mb-0" v-if="billing_address.address_postal_code">
									{{ billing_address.address_postal_code }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import AutoCompleteInput from "@/view/components/AutoCompleteInput";
import { GetCustomer } from "@/core/lib/quotation.lib";
import { find, isEmpty } from "lodash";

export default {
	name: "SelectCustomerSupplier",
	components: {
		AutoCompleteInput,
	},
	model: {
		prop: "value",
		event: "change",
	},
	props: {
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
		show_only_supplier_products: { type: Number },
		updateDetail: {
			type: Object,
			default: () => {
				return {};
			},
		},
		items: {
			type: Array,
			default: () => {
				return [];
			},
		},
		inputId: {
			type: String,
			default: null,
		},
		type: {
			type: String,
			default: null,
		},
		placeholder: {
			type: String,
			default: null,
		},
		rules: {
			type: Array,
			default: () => {
				return [];
			},
		},
		contentClass: {
			type: Object,
			default: null,
		},
	},
	watch: {
		updateDetail: {
			deep: true,
			immediate: true,
			handler(params) {
				(this.customer = { ...params }),
					this.getCustomer(params.id, params.billing_address_id, params.contact_person_id);
			},
		},
	},
	data() {
		return {
			customer: {
				id: null,
				biiling_address_id: null,
				contact_person_id: null,
			},
			billing_addresses_list: [],
			billing_address: {},
			contact_person_list: [],
			contact_person: {},
			customer_detail: {},
			pageLoading: false,
			showOnlySupplierProducts: 0,
		};
	},
	methods: {
		async getCustomer(id, billing_id, contact_id) {
			const _this = this;
			if (!id) {
				_this.billing_address = {};
				_this.contact_person = {};
				_this.customer_detail = {};
				_this.emitCustomerId();
				return;
			}
			// let params = 'customer';
			// if(_this.type=='customer'){
			// 	params = {customer:id};
			// }else{
			// 	params = {supplier:id};
			// }
			_this.pageLoading = true;
			const params = { contact: id };
			const { current_contact, billing_addresses, contact_persons } = await GetCustomer(params);
			_this.billing_address_list = billing_addresses;
			_this.contact_person_list = contact_persons;
			_this.customer_detail = current_contact;
			_this.pageLoading = false;
			if (!billing_id) {
				_this.contact_person = find(contact_persons, (row) => row.primary);
			} else {
				this.handleBillingAddress(billing_id);
			}
			if (!contact_id) {
				_this.billing_address = billing_addresses[0];
			} else {
				this.handleContactPerson(contact_id);
			}
			_this.emitCustomerId();
		},
		emitCustomerId() {
			const _this = this;
			_this.$emit("change", {
				id: _this.customer_detail.id ? _this.customer_detail?.id : null,
				billing_address_id: _this.billing_address?.id ? _this.billing_address?.id : null,
				contact_person_id: _this.contact_person?.id ? _this.contact_person?.id : null,
			});
		},
		is_empty(obj) {
			return isEmpty(obj);
		},
		handleBillingAddress(id) {
			const _address = find(this.billing_address_list, (row) => {
				return row.id == id;
			});
			this.billing_address = _address;
			this.emitCustomerId();
		},
		handleContactPerson(id) {
			const _contactPerson = find(this.contact_person_list, (row) => {
				return row.id == id;
			});
			this.contact_person = _contactPerson;
			this.emitCustomerId();
		},
		inilize() {
			if (this.value && this.value.id) {
				this.customer = {
					id: this.value.id ? this.value.id : null,
					billing_address_id: this.value.billing_address_id ? this.value.billing_address_id : null,
					contact_person_id: this.value.contact_person_id ? this.value.contact_person_id : null,
				};
				/* let params = 'customer';
				if(this.type=='customer'){
					params = {customer:this.value.id};
				}else{
					params = {supplier:this.value.id};
				} */
				const params = { contact: this.value.id };
				GetCustomer(params).then(({ current_contact, billing_addresses, contact_persons }) => {
					this.customer_detail = current_contact;
					this.billing_address_list = billing_addresses;
					this.contact_person_list = contact_persons;
					if (this.customer.billing_address_id) {
						this.handleBillingAddress(this.customer.billing_address_id);
					}
					if (this.customer.contact_person_id) {
						this.handleContactPerson(this.customer.contact_person_id);
					}
				});
			}
		},
	},
	mounted() {
		this.getCustomer(this.value.id, this.value.biiling_address_id, this.value.contact_person_id);
		//this.inilize()
		if (this.show_only_supplier_products) {
			this.showOnlySupplierProducts = this.show_only_supplier_products;
		}
	},
};
</script>
<style scoped>
.billing-active {
	position: absolute;
	left: -18px;
	top: 8px;
}
</style>
